<!--suppress JSUnresolvedVariable -->
<template>
  <div class="mt-4 ml-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">用户列表</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-4 mx-1 px-3">
      <div slot="header">
        <el-button
          @click="addAdminUser()"
          v-if="adminPermissions.includes('/adminUser/admin/addUser')"
          size="small"
          type="primary"
          plain
        >
          新增用户
        </el-button>

        <el-popconfirm
          placement="right"
          icon="el-icon-info"
          iconColor="red"
          title="确定删除选中的用户吗？"
          @onConfirm="deleteUsers()"
        >
          <el-button
            slot="reference"
            class="ml-3"
            v-if="adminPermissions.includes('/adminUser/admin/deleteUser')"
            plain
            type="danger"
            size="small"
          >
            批量删除
          </el-button>
        </el-popconfirm>
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%;min-height: 450px"
        stripe
        v-loading="loading"
        element-loading-text="拼命加载中"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="ID">
                <span>{{ props.row.userId }}</span>
              </el-form-item>
              <el-form-item label="用户名">
                <span>{{ props.row.username }}</span>
              </el-form-item>
              <el-form-item label="姓名">
                <span>{{ props.row.nickname }}</span>
              </el-form-item>
              <el-form-item label="手机号">
                <span>{{ props.row.phoneNumber }}</span>
              </el-form-item>
              <el-form-item label="邮箱">
                <span>{{ props.row.email }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="userId"
          label="ID"
          sortable
          align="center"
          width="60"
        >
        </el-table-column>
        <el-table-column prop="username" label="用户名" align="center">
        </el-table-column>
        <el-table-column prop="nickname" label="姓名" align="center">
        </el-table-column>
        <el-table-column prop="phoneNumber" label="手机号" align="center">
        </el-table-column>
        <el-table-column label="状态" sortable align="center" width="138">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="激活"
              inactive-text="禁用"
              :disabled="
                !adminPermissions.includes(
                  '/adminUser/admin/changeUserStatus'
                ) || scope.row.userId === 1
              "
              @change="value => commitStatusChange(value, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="145" fixed="right">
          <template slot-scope="scope">
            <el-button
              @click="editUser(scope.row.userId)"
              v-if="adminPermissions.includes('/adminUser/admin/updateUser')"
              type="primary"
              plain
              size="small"
            >
              编辑
            </el-button>
            <el-button
              type="danger"
              slot="reference"
              plain
              size="small"
              @click="deleteUser(scope.row.userId)"
              :disabled="scope.row.userId === 1"
              v-if="adminPermissions.includes('/adminUser/admin/deleteUser')"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: "UserInfo",
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      userIds: [],
      adminPermissions: this.$store.state.adminPermissions,
      loading: false
    };
  },
  mounted() {
    this.listUsers();
  },
  methods: {
    listUsers() {
      this.loading = true;
      this.axios.get("/adminUser/admin/userList").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.tableData = resp.data.data;
          this.loading = false;
        }
      });
    },
    addAdminUser() {
      this.$router.push({ name: "AddAdminUser" }).catch();
    },
    commitStatusChange(value, user) {
      if (user.username !== "admin") {
        this.axios
          .post("/adminUser/admin/changeUserStatus", {
            userId: user.userId,
            status: value
          })
          .then(resp => {
            if (resp && resp.data.code === 10000 && resp.data.success) {
              // this.listUsers();
              if (value) {
                this.$message("用户 [" + user.username + "] 已启用");
              } else {
                this.$message("用户 [" + user.username + "] 已禁用");
              }
            }
          });
      } else {
        user.status = true;
        this.$alert("不能禁用管理员账户");
      }
    },
    editUser(userId) {
      this.$router
        .push({ name: "EditUserInfo", params: { userId: userId } })
        .catch();
    },
    deleteUser(userId) {
      if (userId === 1) {
        this.$alert("不能删除管理员账户");
        return;
      }
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .delete("/adminUser/admin/deleteUser", {
              params: {
                userId: userId
              }
            })
            .then(resp => {
              if (resp && resp.data.code === 10000 && resp.data.success) {
                this.listUsers();
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    deleteUsers() {
      this.multipleSelection.forEach(user => {
        this.userIds.push(user.userId);
      });
      if (this.userIds.includes(1)) {
        this.userIds = [];
        this.$message({
          type: "warning",
          message: "不能删除管理员账户!"
        });
        return;
      }
      this.axios
        .post("/adminUser/admin/deleteUserList/" + this.userIds)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.listUsers();
            this.userIds = [];
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          }
        });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
</script>

<!--suppress CssUnusedSymbol -->
<style>
.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-left: 60px;
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
</style>
